import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";

import styles from "./Loader.module.css";

const cx = classNames.bind(styles);

type Props = {
  delay?: number;
};

export const Loader: React.FC<Props> = (props) => {
  const [isVisible, setIsVisible] = useState<boolean>(
    props.delay ? false : true
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, props.delay);

    return () => clearTimeout(timeout);
  }, []);

  if (!isVisible) {
    return null;
  }

  return <div className={cx("loader")} />;
};
